import { useTranslation } from 'react-i18next';

import logo from '@assets/logos/astropay-logo.png';
import { APImage } from '@components/atoms/APImage';
import { Typography } from '@components/atoms/Typography';

export const GenericErrorPage = () => {
  const { t } = useTranslation();

  return (
    <div className="h-screen w-full justify-center items-center flex flex-col bg-[#F3F6F6] p-8">
      <div className="flex flex-col max-w-sm text-center justify-center items-center">
        <div>
          <APImage
            img={logo}
            width={114}
            height={29}
            alt={t('AstroPayDownload.title')}
            className="mb-3"
          />
        </div>
        <Typography
          text={t('CommonMessages.errorMessages.somethingWentWrong')}
          className="text-sm text-red-600"
        />
        <Typography
          text={t('CommonMessages.errorMessages.tryAgainLater')}
          className="text-sm text-gray-500 m-2"
        />
      </div>
    </div>
  );
};
